import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchJourneyIdentityDocuments(params) {
  try {
    const journeyIdentityDocuments = yield call(function () {
      return Api.get(`/journey/id-documents/${params.uuid}`)
    });
    yield put({type: 'FETCH.JOURNEY_IDENTITY_DOCUMENTS.SUCCESS', journeyIdentityDocuments});
  } catch (error) {
    yield put({type: 'FETCH.JOURNEY_IDENTITY_DOCUMENTS.FAILURE', error});
  }
}

function* deleteJourneyIdentityDocuments(params) {
  try {
    const journeyIdentityDocuments = yield call(function () {
      return Api.delete(`/journey/id-documents/${params.uuid}?key=${params.key}`)
    });
    yield put({type: 'DELETE.JOURNEY_IDENTITY_DOCUMENTS.SUCCESS', journeyIdentityDocuments});
  } catch (error) {
    yield put({type: 'DELETE.JOURNEY_IDENTITY_DOCUMENTS.FAILURE', error});
  }
}

function* updateJourneyIdentityDocuments(params) {
  try {
    const journeyIdentityDocuments = yield call(function () {
      return Api.put(`/journey/id-documents/${params.uuid}`, params.body)
    });
    yield put({type: 'UPDATE.JOURNEY_IDENTITY_DOCUMENTS.SUCCESS', journeyIdentityDocuments});
  } catch (error) {
    yield put({type: 'UPDATE.JOURNEY_IDENTITY_DOCUMENTS.FAILURE', error});
  }
}

export function* watchIdentity() {
  yield takeEvery('FETCH.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', fetchJourneyIdentityDocuments);
  yield takeEvery('DELETE.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', deleteJourneyIdentityDocuments);
  yield takeEvery('UPDATE.JOURNEY_IDENTITY_DOCUMENTS.REQUEST', updateJourneyIdentityDocuments);
}
